module.exports = __webpack_public_path__ + "img/gift-8.247fd23f.jpg";